import { Tooltip as ATooltip } from '@ark-ui/solid/tooltip';
import { Button } from '../forms/button.tsx';
import type { ComponentProps } from 'solid-js';

export function Tooltip(props: ComponentProps<typeof ATooltip.Root>) {
	return <ATooltip.Root positioning={{ placement: 'top' }} openDelay={300} {...props} />;
}

Tooltip.Trigger = function TooltipTrigger(props: ComponentProps<typeof ATooltip.Trigger>) {
	return <ATooltip.Trigger {...props} />;
};

Tooltip.ButtonTrigger = (props: ComponentProps<typeof Button>) => (
	<Tooltip.Trigger
		asChild={(p) => (
			// @ts-expect-error too complex
			<Button {...p()} {...props} />
		)}
	/>
);

type ContentProps = ComponentProps<typeof ATooltip.Content>;

Tooltip.Content = function TooltipContent(props: ContentProps) {
	return (
		<ATooltip.Positioner>
			<ATooltip.Content
				{...props}
				class="pointer-events-none max-w-[calc(100dvw-1rem)] origin-(--transform-origin) rounded-lg bg-yellow-400 px-3 py-2 font-normal text-wrap text-zinc-950 shadow backdrop-blur duration-100 select-none data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom-25 data-[state=closed]:zoom-out-50 data-[state=closed]:fade-out data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom-50 data-[state=open]:zoom-in-50 data-[state=open]:fade-in"
				style={{ '--arrow-background': 'oklch(85.2% 0.199 91.936)' }}
			>
				<ATooltip.Arrow>
					<ATooltip.ArrowTip class="" />
				</ATooltip.Arrow>
				{props.children}
			</ATooltip.Content>
		</ATooltip.Positioner>
	);
};
